const t = {
  name: "IceCream",
  dimensions: { width: 19, height: 41 },
  content: `
    <g clip-path="url(#clip0_12_1816)">
    <path d="M12.0044 29.033H11.4144L16.0044 24.443V28.033C16.0044 28.583 15.5544 29.033 15.0044 29.033H12.0044ZM9.00439 38.033H8.00439V32.033C8.00439 31.483 8.45439 31.033 9.00439 31.033H10.0044V37.033C10.0044 37.583 9.55439 38.033 9.00439 38.033ZM2.00439 29.033V28.443L16.0044 14.443V21.613L8.59439 29.033H6.00439H2.00439ZM6.59439 2.03296L2.00439 6.62296V3.03296C2.00439 2.48296 2.45439 2.03296 3.00439 2.03296H6.59439ZM2.00439 9.44296L9.41439 2.03296H15.5844L2.00439 15.623V9.44296ZM16.0044 11.623L2.00439 25.623V18.453L16.0044 4.45296V11.623ZM16.0044 0.032959H2.00439C0.904395 0.032959 0.00439453 0.932959 0.00439453 2.03296V29.033C0.00439453 30.133 0.904395 31.033 2.00439 31.033H6.00439V38.033C6.00439 39.133 6.90439 40.033 8.00439 40.033H10.0044C11.1044 40.033 12.0044 39.133 12.0044 38.033V31.033H16.0044C17.1044 31.033 18.0044 30.133 18.0044 29.033V2.03296C18.0044 0.932959 17.1044 0.032959 16.0044 0.032959Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_12_1816">
    <rect width="18" height="40" fill="currentColor" transform="translate(0.00439453 0.032959)"/>
    </clipPath>
    </defs>
    `
};
export {
  t as IceCream
};
